import { MulticastDelegate } from "flavr-common";
export const onWindowResize$ = new MulticastDelegate();
